/**
 * Global app configuration.
 * To rename the app, change VITE_APP_NAME in apps/web/.env
 * That single change will update all UI across the frontend.
 */
export const APP_NAME = (import.meta.env.VITE_APP_NAME as string) || "RentKeep"

/** Mobile app store links. Empty string = button hidden. */
export const APP_STORE_URL = (import.meta.env.VITE_APP_STORE_URL as string) || ""
export const PLAY_STORE_URL = (import.meta.env.VITE_PLAY_STORE_URL as string) || ""

/** Set VITE_MARKETPLACE_ENABLED=true in .env to show marketplace/listings feature. */
export const MARKETPLACE_ENABLED = import.meta.env.VITE_MARKETPLACE_ENABLED === "true"

/** Set VITE_BILLING_ENABLED=true in .env to show pricing/billing features. */
export const BILLING_ENABLED = import.meta.env.VITE_BILLING_ENABLED === "true"

/**
 * Google Analytics 4 measurement ID.
 * Used by <GoogleAnalytics> in all layouts.
 * Set VITE_GA_ID in .env — leave blank to disable tracking.
 */
export const GA_ID = (import.meta.env.VITE_GA_ID as string) || ""

/**
 * Legal / Data Controller configuration.
 * Used only in Privacy Policy and Terms of Service pages.
 * VITE_LEGAL_COMPANY_NAME — the legal entity name shown as data controller.
 * VITE_LEGAL_ADDRESS_ENABLED — set "true" to show the registered address.
 * VITE_LEGAL_ADDRESS — the registered address string (shown only when flag is true).
 */
export const LEGAL_COMPANY_NAME = (import.meta.env.VITE_LEGAL_COMPANY_NAME as string) || `${APP_NAME} Ltd.`
export const LEGAL_ADDRESS_ENABLED = import.meta.env.VITE_LEGAL_ADDRESS_ENABLED === "true"
export const LEGAL_ADDRESS = (import.meta.env.VITE_LEGAL_ADDRESS as string) || ""

/**
 * Contact emails — update in .env before going live.
 * All UI and legal pages source emails from here (single source of truth).
 */
export const EMAIL_SUPPORT = (import.meta.env.VITE_EMAIL_SUPPORT as string) || "support@rent-keep.com"
export const EMAIL_PRIVACY = (import.meta.env.VITE_EMAIL_PRIVACY as string) || "policy-admin@rent-keep.com"
export const EMAIL_LEGAL = (import.meta.env.VITE_EMAIL_LEGAL as string) || "legal@soulspark.games"
export const EMAIL_ADMIN = (import.meta.env.VITE_EMAIL_ADMIN as string) || "admin@rent-keep.com"
